import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Form,
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule,
} from "devextreme-react/form";
import { Button as DxButton } from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import { useAuth } from "hooks/useAuth";

const FeedbackForm = ({ onClose }) => {
  const { account } = useAuth();
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    name: account.name,
    email: account.username,
    rating: 0,
    category: "",
    comment: "",
    contactMe: false,
  });

  const categories = [
    "User Interface",
    "Features",
    "Performance",
    "Ease of use",
    "Support",
    "Other",
  ];

  const handleFieldChange = (e) => {
    if (e.name) {
      setFormData({
        ...formData,
        [e.name]: e.value,
      });
    }
  };

  const handleRatingClick = (rating) => {
    setFormData({
      ...formData,
      rating,
    });
  };

  const handleSubmit = () => {
    const { isValid } = formRef.current.instance().validate();

    if (!isValid || formData.rating === 0) {
      if (formData.rating === 0) {
        notify("Please give a rating.", "error", 3000);
      }
      return;
    }

    console.log("Submitted data:", formData);

    notify({
      message: "Thank you for your feedback! We appreciate your contribution.",
      type: "success",
      displayTime: 4000,
      position: { at: "bottom center", my: "bottom center", offset: "0 -30px" },
    });

    setFormData({
      name: "",
      email: "",
      rating: 0,
      category: "",
      comment: "",
      contactMe: false,
    });

    onClose();
  };

  return (
    <div>
      <Button variant="link" className="mb-3 ps-0" onClick={onClose}>
        <FontAwesomeIcon icon="arrow-left" className="me-2" />
        Retour
      </Button>

      <h4 className="mb-3">Evaluation and Suggestions</h4>

      <Form
        ref={formRef}
        formData={formData}
        onFieldDataChanged={handleFieldChange}
        labelMode="floating"
      >
        <GroupItem colCount={2}>
          <SimpleItem dataField="name" editorType="dxTextBox">
            <RequiredRule message="The name is required" />
            <Label text="Name" />
          </SimpleItem>

          <SimpleItem
            dataField="email"
            editorType="dxTextBox"
            editorOptions={{
              mode: "email",
            }}
          >
            <RequiredRule message="The email is required" />
            <Label text="Email" />
          </SimpleItem>
        </GroupItem>

        <GroupItem>
          <SimpleItem
            dataField="category"
            editorType="dxSelectBox"
            editorOptions={{
              placeholder: "",
              items: categories,
            }}
          >
            <RequiredRule message="The category is required" />
            <Label text="Category" />
          </SimpleItem>
        </GroupItem>

        <GroupItem>
          <SimpleItem>
            <Label text="Rating" />
            <div className="mb-2 mt-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <FontAwesomeIcon
                  key={star}
                  icon="star"
                  className={`fs-4 me-1 cursor-pointer ${
                    star <= formData.rating ? "text-warning" : "text-300"
                  }`}
                  onClick={() => handleRatingClick(star)}
                  style={{ cursor: "pointer" }}
                />
              ))}
              {formData.rating > 0 && (
                <span className="ms-2 text-700">{formData.rating}/5</span>
              )}
            </div>
          </SimpleItem>
        </GroupItem>

        <GroupItem>
          <SimpleItem
            dataField="comment"
            editorType="dxTextArea"
            editorOptions={{
              height: 120,
              maxLength: 500,
              spellcheck: true,
            }}
          >
            <RequiredRule message="The comment is required" />
            <Label text="Comment" />
          </SimpleItem>
        </GroupItem>

        <GroupItem>
          <SimpleItem
            dataField="contactMe"
            editorType="dxCheckBox"
            editorOptions={{
              text: "I would like to be contacted about this feedback",
            }}
          />
        </GroupItem>
      </Form>

      <div className="d-flex justify-content-end mt-4">
        <DxButton
          text="Cancel"
          type="danger"
          stylingMode="outlined"
          onClick={onClose}
          className="me-2"
        />
        <DxButton
          text="Send"
          type="success"
          stylingMode="outlined"
          icon="sendfilled"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default FeedbackForm;
